import React from "react";

export const CompareProductButton = ({
  children,
}: {
  children: React.ReactNode;
}) => (
  <div style={{ display: "block" }} className="btn-container">
    {children}
  </div>
);

export const ListOutletButton = ({
  width,
  children,
}: {
  width: number;
  children: React.ReactNode;
}) => (
  <div
    className="btn-container"
    style={width >= 600 ? {} : { marginLeft: "-30px" }}
  >
    {children}
  </div>
);

export const GridOutletOrQuoteButton = ({
  children,
}: {
  children: React.ReactNode;
}) => (
  <div style={{ padding: "0px" }} className="btn-container">
    {children}
  </div>
);

export const ListQuoteButton = ({
  children,
}: {
  children: React.ReactNode;
}) => (
  <div style={{ maxWidth: "150px" }} className="btn-container">
    {children}
  </div>
);

export const CustomizableCarouselButton = ({
  children,
}: {
  children: React.ReactNode;
}) => (
  <div style={{ padding: "0px" }} className="btn-container">
    {children}
  </div>
);

export const DefaultButton = ({ children }: { children: React.ReactNode }) => (
  <div className="btn-container">{children}</div>
);
